import { useMemo } from 'react';

import { useCardOfferPublisherContext } from '@/microfrontends/listing/shared/context/selectors/cardData';
import { formatPhone } from '@/microfrontends/listing/shared/utils/formatPhone';

import { memoWithDisplayName } from '@/packages/utils';

import { PhoneButton } from './componentns/PhoneButton';
import { type DisplayPhonesOptions } from './types';

type PhoneButtonContainerProps = {
  displayPhonesOptions?: DisplayPhonesOptions;
};

export const CardContactsButtonDesktopContainer = memoWithDisplayName<PhoneButtonContainerProps>(props => {
  const { phones, workHours } = useCardOfferPublisherContext();
  const displayPhonesOptions = useMemo<DisplayPhonesOptions>(() => {
    return (
      props.displayPhonesOptions || {
        countToDisplay: phones.length,
        shouldDisplayWorkHours: true,
      }
    );
  }, [props.displayPhonesOptions, phones]);

  const prettyPhones = phones.map(formatPhone);
  const prettyWorkHours = workHours ? `Работает с ${workHours.workFrom} до ${workHours.workTo}` : null;

  return <PhoneButton displayPhonesOptions={displayPhonesOptions} phones={prettyPhones} workHours={prettyWorkHours} />;
}, 'PhoneButtonContainer');
